import { useTranslation } from "react-i18next";

import CurrencyCell from "@/components/ui/v1/table/CurrencyCell";
import { TableLinkCell } from "@/components/ui/v1/table/TableCells";
import { ChannelInvoiceType } from "@/types/response/ChannelInvoiceType";
import { TableColumn } from "@/types/table/tableProps";

export const useChannelInvoiceTableColumns = () => {
  const { t } = useTranslation();

  const channelInvoiceTableColumns: TableColumn<ChannelInvoiceType>[] = [
    {
      accessor: "client.name",
      Cell: (row: ChannelInvoiceType) => (
        <TableLinkCell
          label={row.clientName}
          link={`/clients/${row.clientId2}`}
        />
      ),
      header: t("common.client"),
      width: "25%",
    },
    {
      accessor: "budget",
      Cell: (row: ChannelInvoiceType) => <CurrencyCell value={row.budget} />,
      header: t("common.budget"),
      width: "25%",
      sortable: false,
    },
    {
      accessor: "amount",
      Cell: (row: ChannelInvoiceType) => (
        <div className="flex justify-end w-full">
          {row.amount === null || row.amount === undefined ? (
            <span>-</span>
          ) : (
            <CurrencyCell value={row.amount} />
          )}
        </div>
      ),
      header: t("common.invoice"),
      width: "20%",
      textAlign: "right",
      sortable: false,
    },
  ];

  return {
    channelInvoiceTableColumns,
    dialog: null,
  };
};
